import { ODataFilter } from '../../components/odata-filter/models/odata-filter';

export class AutomationModel {
  id: string;
  automationTrigger: AutomationTrigger;
  automationAction: AutomationAction;

  constructor(data?: AutomationModel) {
    if (!data) return;
    this.id = data.id;
    this.automationTrigger = new AutomationTrigger(data.automationTrigger);
    this.automationAction = new AutomationAction(data.automationAction);
  }

  get triggeringActionTypeTitle(): string {
    switch (this.automationTrigger.triggeringActionType) {
      case TriggeringActionType.FormSubmitted:
        return 'Form Submitted';
      default:
        return '';
    }
  }
}

export class FormAutomationModel {
  id: string;
  actionEntityName: string;
  conditionCount: number;

  constructor(data?: FormAutomationModel) {
    if (!data) return;
    this.id = data.id;
    this.actionEntityName = data.actionEntityName;
    this.conditionCount = data.conditionCount;
  }
}

export class AutomationTrigger {
  id: string;
  triggeringActionType: TriggeringActionType;
  entityId: string;

  constructor(data?: AutomationTrigger) {
    if (!data) return;
    this.id = data.id;
    this.triggeringActionType = data.triggeringActionType;
    this.entityId = data.entityId;
  }
}

export class AutomationAction {
  id: string;
  automationType: AutomationType;
  entityId: string;
  oDataFilters: string[];
  oDataQuery: string;

  constructor(data?: AutomationAction) {
    if (!data) return;
    this.id = data.id;
    this.automationType = data.automationType;
    this.entityId = data.entityId;
    this.oDataFilters = data.oDataFilters ?? [];
    this.oDataQuery = data.oDataQuery;
  }
}

export enum AutomationType {
  AddCredentialApplication = 'AddCredentialApplication',
}

export enum TriggeringActionType {
  FormSubmitted = 'FormSubmitted',
}
